import { ILibreCipher } from '@/contracts/modules/libre/cipher/ILibreCipher'
import { EnumLibrePart } from '@/contracts/modules/libre/enum/EnumLibrePart'
import { EnumLibreError } from '@/contracts/modules/libre/enum/EnumLibreError'
import { GCM_IV_BYTES, decryptGcm, encryptGcm } from '@/helpers/aesGcm'
import { base64UrlToBytes, bytesToBase64Url } from '@/helpers/base64url'

const KEY_ALGORITHM: AesKeyGenParams = { name: 'AES-GCM', length: 256 }
const KEY_USAGES: KeyUsage[] = ['encrypt', 'decrypt']
// тег AES-GCM — 16 байт: строка короче IV и тега не может быть шифротекстом
const TAG_BYTES = 16

/** AAD — часть узла: шифротекст места не расшифруется как данные */
function aad(part: EnumLibrePart): Uint8Array {
  return new TextEncoder().encode(`libre:${part}`)
}

/** Повторяет NoteCipher: новый случайный IV на каждое шифрование, строка — base64url от IV и шифротекста */
export class LibreCipher implements ILibreCipher {
  createKey(): Promise<CryptoKey> {
    return crypto.subtle.generateKey(KEY_ALGORITHM, true, KEY_USAGES)
  }

  async encrypt(key: CryptoKey, part: EnumLibrePart, text: string): Promise<string> {
    const iv = crypto.getRandomValues(new Uint8Array(GCM_IV_BYTES))
    const cipher = await encryptGcm(key, iv, aad(part), new TextEncoder().encode(text))
    const packed = new Uint8Array(iv.length + cipher.length)
    packed.set(iv)
    packed.set(cipher, iv.length)

    return bytesToBase64Url(packed)
  }

  async decrypt(key: CryptoKey, part: EnumLibrePart, cipher: string): Promise<string> {
    try {
      const packed = base64UrlToBytes(cipher)
      if (packed.length < GCM_IV_BYTES + TAG_BYTES) {
        throw new Error(EnumLibreError.CANNOT_DECRYPT)
      }
      const bytes = await decryptGcm(key, packed.slice(0, GCM_IV_BYTES), aad(part), packed.slice(GCM_IV_BYTES))

      return new TextDecoder('utf-8', { fatal: true }).decode(bytes)
    } catch {
      throw new Error(EnumLibreError.CANNOT_DECRYPT)
    }
  }
}
